<template>
  <li class="dropdown notification-dropdown">
    <a href="javascript:;" class="dropdown-toggle nk-quick-nav-icon" data-toggle="dropdown">
      <div class="icon-status icon-status-info" v-if="unreadCount > 0">
        <nio-icon icon="ni-bell"></nio-icon>
      </div>
      <nio-icon icon="ni-bell" v-else></nio-icon>
    </a>
    <div class="dropdown-menu dropdown-menu-xl dropdown-menu-right">
      <div class="dropdown-head">
        <span class="sub-title nk-dropdown-title">Notifications</span>
        <a href="#">Mark All as Read</a>
      </div>
      <div class="dropdown-body">
        <div class="nk-notification">
          <notification-items></notification-items>
        </div><!-- .nk-notification -->
      </div><!-- .nk-dropdown-body -->
      <div class="dropdown-foot center">
        <router-link :to="{name: 'Notifications'}">View All</router-link>
      </div>
    </div>
  </li>
</template>

<script>
import NotificationItems from "@core/layouts/app-nav-bar/components/NotificationItems";
import { mapGetters} from "vuex"
export default {
  name: "NotificationDropdown",
  components: {NotificationItems},
  computed: {
    ...mapGetters({
      unreadCount: 'notifications/unreadCount',
    })
  },
}
</script>
